import appService from '../js/appservice/index'
import funcs from '../js/helpers/misc'
import { getErrorMessage } from '../js/helpers/axioshelper'

const state = {
  instructions: [],
  currentInstruction: {},
  currentInstructionLanguageId: '',
  isEditingInstructionContent: false
}

const getters = {
  instructions: state => state.instructions,
  currentInstruction: state => state.currentInstruction,
  isEditingInstructionContent: state => state.isEditingInstructionContent
}

const actions = {
  getAllInstructions(context) {
    return new Promise((resolve, reject) => {
      appService.instructions
        .getAllInstructions()
        .then(data => {
          context.commit('getAllInstructions', data)
          resolve()
        })
        .catch(error => {
          reject(getErrorMessage(error))
        })
    })
  },
  getInstruction(context, instructionInfo) {
    return new Promise((resolve, reject) => {
      appService.instructions
        .getInstruction(
          instructionInfo.instructionId,
          instructionInfo.languageId
        )
        .then(data => {
          context.commit('selectCurrentInstruction', data)
          resolve()
        })
        .catch(error => {
          reject(getErrorMessage(error))
        })
    })
  },
  selectCurrentInstruction(context, instruction) {
    context.commit('selectCurrentInstruction', instruction)
  },
  setIsEditingInstructionContent(context, value) {
    context.commit('setIsEditingInstructionContent')
  },
  saveInstructionDetails(context, instruction) {
    return new Promise((resolve, reject) => {
      if (instruction.id) {
        appService.instructions
          .updateInstruction(instruction)
          .then(data => {
            context.commit('updateInstruction', data)
            resolve()
          })
          .catch(error => {
            state.scalesError = error.data
            reject(error.data)
          })
      } else {
        appService.instructions
          .addInstruction(instruction)
          .then(data => {
            context.commit('addInstruction', data)
            resolve()
          })
          .catch(error => {
            state.scalesError = error.data
            reject(error.data)
          })
      }
    })
  },
  deleteTranslation(context, translation) {
    return new Promise((resolve, reject) => {
      if (translation.id) {
        appService.instructions
          .deleteTranslation(state.currentInstruction.id, translation.id)
          .then(data => {
            context.commit('deleteTranslation', translation)
            resolve()
          })
          .catch(error => {
            reject(error.data)
          })
      } else {
        context.commit('deleteTranslation', translation)
        resolve()
      }
    })
  },
  deleteInstruction(context, instruction) {
    return new Promise((resolve, reject) => {
      appService.instructions
        .deleteInstruction(instruction.id)
        .then(data => {
          context.commit('deleteInstruction', instruction)
          resolve()
        })
        .catch(error => {
          reject(error.data)
        })
    })
  },
  getQuestions(context, indata) {
    return new Promise((resolve, reject) => {
      appService.instructions
        .getQuestions(indata.scaleId, indata.languageId)
        .then(data => {
          context.commit('saveQuestions', data)
          resolve(data)
        })
        .catch(error => {
          state.scalesError = error
          reject(error)
        })
    })
  },
  saveQuestions(context, indata) {
    return new Promise((resolve, reject) => {
      appService.instructions
        .saveQuestions(indata.instructionId, indata.data)
        .then(data => {
          context.commit('saveQuestions', data)
          resolve(data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  savePage(context, pageInfo) {
    return new Promise((resolve, reject) => {
      if (pageInfo.page.id) {
        appService.instructions
          .updatePage(pageInfo.instruction.id, pageInfo.page)
          .then(data => {
            context.commit('selectCurrentInstruction', data)
            resolve(data)
          })
          .catch(error => {
            state.scalesError = error.data
            reject(error.data)
          })
      } else {
        appService.instructions
          .addPage(pageInfo.instruction.id, pageInfo.page)
          .then(data => {
            context.commit('selectCurrentInstruction', data)
            resolve(data)
          })
          .catch(error => {
            state.scalesError = error.data
            reject(error.data)
          })
      }
    })
  },
  deletePage(context, pageInfo) {
    return new Promise((resolve, reject) => {
      appService.instructions
        .deletePage(pageInfo.instructionId, pageInfo.pageId)
        .then(() => {
          resolve()
        })
        .catch(error => {
          reject(error)
        })
    })
  }
}

const mutations = {
  getAllInstructions(state, data) {
    state.instructions = data
  },
  selectCurrentInstruction(state, data) {
    state.currentInstruction = data
  },
  setIsEditingInstructionContent(state, data) {
    state.isEditingInstructionContent = data
  },
  addInstruction(state, data) {
    state.currentInstruction = data
    state.instructions.push(data)
  },
  updateInstruction(state, data) {
    state.currentInstruction = data
  },
  deleteInstruction(state, data) {
    var index = funcs.getIndexInCollection('id', data.id, state.instructions)
    if (index !== -1) {
      state.instructions.splice(index, 1)
    }
  },
  deleteTranslation(state, data) {
    var index = funcs.getIndexInCollection(
      'languageId',
      data.languageId,
      state.currentInstruction.translations
    )
    if (index !== -1) {
      state.currentInstruction.translations.splice(index, 1)
    }
  },
  saveQuestions(state, data) {
    state.questionCollection = data
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
